import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/auth/reset_password.tsx");
